import type { TestLineOption } from '@util/testCatalogue'
import * as yup from 'yup'

const imagingStudyOptionSchema = yup.object({
  label: yup.string().required(),
  value: yup
    .mixed<number | string>()
    .required()
    .test('imaging-study-value', 'Invalid study', val =>
      typeof val === 'number' ? Number.isInteger(val) && val > 0 : typeof val === 'string' && val.trim().length > 0
    ),
  source: yup.mixed<'facility' | 'catalogue' | 'free_text'>().oneOf(['facility', 'catalogue', 'free_text']).optional(),
  priced: yup.boolean().optional(),
  performed_at: yup.mixed<'our_lab' | 'outside'>().oneOf(['our_lab', 'outside']).optional()
})

/** Doctor encounter — order imaging modal (maps to `imaging_order` JSON:API create body). */
export const imagingOrderFormSchema = yup.object({
  imaging_studies: yup
    .array()
    .of(imagingStudyOptionSchema)
    .min(1, 'Select at least one study')
    .required('Select at least one study'),
  note: yup.string().trim().default('')
})

export type ImagingOrderFormValues = {
  imaging_studies: TestLineOption[]
  note: string
}
